import axios from 'axios';

export default {
    updateSawnForPleatingSawline(recordSawlineId, checked) {
        return axios.post('/sawlist/updateSawnForPleatingSawline/', {
            recordSawlineId,
            checked,
        });
    },
    fetchSawlinesForPleatinglistrecord(pleatinglistRecordId) {
        return axios.post('/sawlist/fetchSawlinesForPleatinglistrecord/', {
            pleatinglistRecordId,
        });
    },
    updateLine(productId, sawlineId, finished) {
        return axios.post('/sawlist/updateLine/', {
            productId,
            sawlineId,
            finished,
        });
    },
    fetch(productNr) {
        return axios.post('/sawlist/fetch/', { productNr });
    },
    fetchSawlinesForPaintlistrecordV2(paintlistrecordId) {
        return axios.post('/sawlist/fetchSawlinesForPaintlistrecordV2/', {
            paintlistrecordId,
        });
    },
    fetchSawlinesForPaintlistrecord(paintlistrecordId) {
        return axios.post('/sawlist/fetchSawlinesForPaintlistrecord/', {
            paintlistrecordId,
        });
    },
    updateSawnForSawline(paintlistrecordSawlineId, checked) {
        return axios.post('/sawlist/updateSawnForSawline/', {
            paintlistrecordSawlineId,
            checked,
        });
    },
    fetchSawlinesForPartslistRecord(partslistrecordId) {
        return axios.post('/sawlist/fetchSawlinesForPartslistRecord/', {
            partslistrecordId,
        });
    },
    errorReport(productId, selectedOption, sawlineIds, employeeId) {
        const payload = {
            productId,
            selectedOption,
            sawlineIds,
            employeeId,
        };
        return axios.post('/sawlist/errorReport/', payload);
    },
};
